var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.screenshotUrl)?_c('img',{staticClass:"w-100",attrs:{"src":_vm.screenshotUrl,"alt":("Screenshot for " + _vm.url)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }